(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2775],{

/***/ 7645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4588));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 3644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(9658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(7294));
var _loadableContext = __webpack_require__(3644);
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var _this1 = this, res = _this1._res, opts = _this1._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 2301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w4": function() { return /* binding */ GridSection; }
/* harmony export */ });
/* unused harmony exports GridSectionColorEnum, GridSectionAlignmentEnum */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _GridSection_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4869);
/* harmony import */ var _GridSection_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_GridSection_module_css__WEBPACK_IMPORTED_MODULE_3__);
// import node_modules




// import styles

var GridSectionColorEnum;
(function(GridSectionColorEnum) {
    GridSectionColorEnum["allports"] = "allports";
    GridSectionColorEnum["anakiwa"] = "anakiwa";
    GridSectionColorEnum["desertStorm"] = "desertStorm";
    GridSectionColorEnum["energyYellow"] = "energyYellow";
    GridSectionColorEnum["java"] = "java";
    GridSectionColorEnum["tuatara"] = "tuatara";
    GridSectionColorEnum["white"] = "white";
})(GridSectionColorEnum || (GridSectionColorEnum = {}));
var GridSectionAlignmentEnum;
(function(GridSectionAlignmentEnum) {
    GridSectionAlignmentEnum["bottom"] = "bottom";
    GridSectionAlignmentEnum["middle"] = "middle";
    GridSectionAlignmentEnum["top"] = "top";
})(GridSectionAlignmentEnum || (GridSectionAlignmentEnum = {}));
// define component
var GridSection = function(param) {
    var bgColor = param.bgColor, bgImage = param.bgImage, bgImageDark = param.bgImageDark, bgPosition = param.bgPosition, children = param.children, columns = param.columns, sectionId = param.sectionId, verticalAlignment = param.verticalAlignment, zIndex = param.zIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_GridSection_module_css__WEBPACK_IMPORTED_MODULE_3___default().section), bgColor && (_GridSection_module_css__WEBPACK_IMPORTED_MODULE_3___default())["color-".concat(bgColor)], bgImage && (_GridSection_module_css__WEBPACK_IMPORTED_MODULE_3___default())[bgImage], bgImageDark && (_GridSection_module_css__WEBPACK_IMPORTED_MODULE_3___default())["".concat(bgImageDark, "-dark")]),
        id: sectionId,
        style: {
            backgroundPosition: bgPosition,
            zIndex: zIndex || 0
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_GridSection_module_css__WEBPACK_IMPORTED_MODULE_3___default().container), columns && (_GridSection_module_css__WEBPACK_IMPORTED_MODULE_3___default())["col-".concat(columns)], verticalAlignment && (_GridSection_module_css__WEBPACK_IMPORTED_MODULE_3___default())[verticalAlignment]),
            children: children
        })
    });
};
GridSection.defaultProps = {
    bgColor: "white",
    bgImage: undefined,
    bgImageDark: undefined,
    bgPosition: undefined,
    columns: 1,
    sectionId: "",
    verticalAlignment: "middle",
    zIndex: 0
};
GridSection.propTypes = {
    columns: prop_types__WEBPACK_IMPORTED_MODULE_4__.number,
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf(Object.values(GridSectionColorEnum)),
    bgImage: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    bgImageDark: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    bgPosition: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired,
    sectionId: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    verticalAlignment: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf(Object.values(GridSectionAlignmentEnum)),
    zIndex: prop_types__WEBPACK_IMPORTED_MODULE_4__.number
};
/* harmony default export */ __webpack_exports__["ZP"] = (GridSection);


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorylinerImage": function() { return /* binding */ StorylinerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2848);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable react/jsx-props-no-spreading */ // import node_modules






// import styles

// Define component
var StorylinerImage = function(param) {
    var className = param.className, hasShadow = param.hasShadow, hasWhiteBg = param.hasWhiteBg, height = param.height, imageId = param.imageId, isBlack = param.isBlack, isRounded = param.isRounded, isWhite = param.isWhite, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default().image), isBlack && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-black"]), isWhite && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-white"]), isRounded && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-rounded"]), hasShadow && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["has-shadow"]), hasWhiteBg && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["white-bg"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            alt: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            className: className,
            height: height,
            layout: "responsive",
            loading: "lazy",
            src: imageId,
            title: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            width: width
        })
    });
};
StorylinerImage.defaultProps = {
    className: undefined,
    hasShadow: undefined,
    hasWhiteBg: undefined,
    isBlack: false,
    isRounded: true,
    isWhite: false
};
StorylinerImage.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    hasWhiteBg: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    isBlack: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isRounded: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWhite: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (StorylinerImage);


/***/ }),

/***/ 6557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GenresGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/templates/dist/index.modern.js + 60 modules
var index_modern = __webpack_require__(1860);
// EXTERNAL MODULE: ./src/types/index.ts + 5 modules
var types = __webpack_require__(6198);
// EXTERNAL MODULE: ./src/components/atoms/Column.tsx
var Column = __webpack_require__(4992);
// EXTERNAL MODULE: ./src/components/atoms/Section.tsx
var Section = __webpack_require__(9748);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/design/dist/design.esm.js + 119 modules
var design_esm = __webpack_require__(4468);
// EXTERNAL MODULE: ./src/components/atoms/StorylinerImage.tsx
var StorylinerImage = __webpack_require__(4090);
// EXTERNAL MODULE: ./src/components/cards/GenreCard.module.css
var GenreCard_module = __webpack_require__(7121);
var GenreCard_module_default = /*#__PURE__*/__webpack_require__.n(GenreCard_module);
;// CONCATENATED MODULE: ./src/components/cards/GenreCard.tsx
/* eslint-disable react/forbid-prop-types */ // import node_modules




// import components

// import styles

// define component
var GenreCard = function(param) {
    var name = param.name, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (GenreCard_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (GenreCard_module_default()).card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (GenreCard_module_default()).cardImageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StorylinerImage["default"], {
                        className: (GenreCard_module_default()).cardImage,
                        height: 540,
                        imageId: image,
                        title: name,
                        width: 540
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (GenreCard_module_default()).cardNameContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                        tag: "h4",
                        children: name
                    })
                })
            ]
        })
    });
};
GenreCard.propTypes = {
    name: prop_types.string.isRequired,
    image: prop_types.string.isRequired
};
GenreCard.displayName = "GenreCard";
/* harmony default export */ var cards_GenreCard = (GenreCard);

// EXTERNAL MODULE: ./src/components/grids/GenresGrid.module.css
var GenresGrid_module = __webpack_require__(9888);
var GenresGrid_module_default = /*#__PURE__*/__webpack_require__.n(GenresGrid_module);
;// CONCATENATED MODULE: ./src/components/grids/GenresGrid.tsx
// import node_modules



// import types


// import components



// import styles

// define component
var GenresGgrid = function(param) {
    var bgColor = param.bgColor, templateGenres = param.templateGenres;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
        bgColor: bgColor,
        isPaddingLess: true,
        mobileFlexDirection: "row",
        zIndex: 1,
        children: [
            templateGenres.map(function(genre) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                    className: (GenresGrid_module_default()).column,
                    isPaddingless: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_GenreCard, {
                        name: genre.name,
                        image: genre.coverImageSquared
                    })
                }, genre.slug);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                className: (GenresGrid_module_default()).column,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            })
        ]
    });
};
GenresGgrid.propTypes = {
    bgColor: prop_types.oneOf(Object.values(types/* SectionColorEnum */.TJ)).isRequired,
    templateGenres: prop_types.arrayOf(prop_types.shape({
        coverImageSquared: prop_types.string.isRequired,
        name: prop_types.string.isRequired,
        slug: prop_types.oneOf(Object.values(index_modern/* TemplateGenreSlugEnum */.V)).isRequired
    }).isRequired).isRequired
};
/* harmony default export */ var GenresGrid = (GenresGgrid);


/***/ }),

/***/ 6009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4992);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _atoms_StorylinerImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4090);
/* eslint-disable jsx-a11y/alt-text */ // import node_modules



// import types

// import components



// define component
var LogosGrid = function(param) {
    var bgColor = param.bgColor, logos = param.logos;
    // init vars
    var isBlack = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return bgColor === _types__WEBPACK_IMPORTED_MODULE_2__/* .SectionColorEnum.energyYellow */ .TJ.energyYellow;
    }, [
        bgColor
    ]);
    // init render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        mobileFlexDirection: "row",
        zIndex: 1,
        children: logos === null || logos === void 0 ? void 0 : logos.map(function(logo) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                cols: 5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_StorylinerImage__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    height: 360,
                    title: logo.alt,
                    isWhite: !isBlack,
                    isBlack: isBlack,
                    imageId: logo.src,
                    width: 720
                })
            }, logo.src);
        })
    });
};
LogosGrid.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_2__/* .SectionColorEnum */ .TJ)).isRequired,
    logos: prop_types__WEBPACK_IMPORTED_MODULE_6__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_6__.shape({
        alt: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
        src: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired
    }).isRequired).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (LogosGrid);


/***/ }),

/***/ 3237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grids_PostsGrid; }
});

// UNUSED EXPORTS: PostGridColorEnum

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/atoms/Column.tsx
var Column = __webpack_require__(4992);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/design/dist/design.esm.js + 119 modules
var design_esm = __webpack_require__(4468);
// EXTERNAL MODULE: ./src/components/atoms/LinkComponent.tsx
var LinkComponent = __webpack_require__(2964);
// EXTERNAL MODULE: ./src/components/atoms/StorylinerImage.tsx
var StorylinerImage = __webpack_require__(4090);
// EXTERNAL MODULE: ./src/components/cards/PostCard.module.css
var PostCard_module = __webpack_require__(765);
var PostCard_module_default = /*#__PURE__*/__webpack_require__.n(PostCard_module);
;// CONCATENATED MODULE: ./src/components/cards/PostCard.tsx
/* eslint-disable react/forbid-prop-types */ // import node_modules




// import components


// import styles

// define component
var PostCard = function(param) {
    var image = param.image, href = param.href, tags = param.tags, title = param.title;
    // init render
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent["default"], {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PostCard_module_default()).card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PostCard_module_default()).imageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StorylinerImage["default"], {
                        imageId: image,
                        height: 600,
                        title: title,
                        width: 960
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PostCard_module_default()).nameContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                        customClasses: (PostCard_module_default()).heading,
                        tag: "h3",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PostCard_module_default()).tagsContainer,
                    children: tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PostCard_module_default()).tag,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                tag: "label",
                                children: "#".concat(tag.replace("-", ""))
                            })
                        }, tag);
                    })
                })
            ]
        })
    });
};
PostCard.propTypes = {
    href: prop_types.string.isRequired,
    image: prop_types.string.isRequired,
    tags: prop_types.arrayOf(prop_types.string.isRequired).isRequired,
    title: prop_types.string.isRequired
};
PostCard.displayName = "PostCard";
/* harmony default export */ var cards_PostCard = (PostCard);

// EXTERNAL MODULE: ./src/components/atoms/GridSection.tsx
var GridSection = __webpack_require__(2301);
;// CONCATENATED MODULE: ./src/components/grids/PostsGrid.tsx
// import node_modules




// import components



var PostGridColorEnum;
(function(PostGridColorEnum) {
    PostGridColorEnum["allports"] = "allports";
    PostGridColorEnum["anakiwa"] = "anakiwa";
    PostGridColorEnum["desertStorm"] = "desertStorm";
    PostGridColorEnum["energyYellow"] = "energyYellow";
    PostGridColorEnum["java"] = "java";
    PostGridColorEnum["tuatara"] = "tuatara";
    PostGridColorEnum["white"] = "white";
})(PostGridColorEnum || (PostGridColorEnum = {}));
// define components
var PostsGrid = function(param) {
    var bgColor = param.bgColor, blogPosts = param.blogPosts;
    // init hooks
    var asPath = (0,router.useRouter)().asPath;
    // init render
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridSection/* GridSection */.w4, {
        bgColor: bgColor,
        columns: 3,
        verticalAlignment: "top",
        children: blogPosts === null || blogPosts === void 0 ? void 0 : blogPosts.map(function(post) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Column/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_PostCard, {
                    href: (asPath === null || asPath === void 0 ? void 0 : asPath.includes("/de/")) ? "/de/blog/".concat(post === null || post === void 0 ? void 0 : post.slug) : "/blog/".concat(post === null || post === void 0 ? void 0 : post.slug),
                    image: post === null || post === void 0 ? void 0 : post.image,
                    tags: post === null || post === void 0 ? void 0 : post.tags,
                    title: post === null || post === void 0 ? void 0 : post.title
                })
            }, post === null || post === void 0 ? void 0 : post.title);
        })
    });
};
PostsGrid.propTypes = {
    bgColor: prop_types.oneOf(Object.values(PostGridColorEnum)).isRequired,
    blogPosts: prop_types.arrayOf(prop_types.shape({
        image: prop_types.string.isRequired,
        slug: prop_types.string.isRequired,
        tags: prop_types.arrayOf(prop_types.string.isRequired).isRequired,
        title: prop_types.string.isRequired
    }).isRequired).isRequired
};
/* harmony default export */ var grids_PostsGrid = (PostsGrid);


/***/ }),

/***/ 4344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ templates_HomeTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/design/dist/design.esm.js + 119 modules
var design_esm = __webpack_require__(4468);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/templates/dist/index.modern.js + 60 modules
var index_modern = __webpack_require__(1860);
// EXTERNAL MODULE: ./src/components/atoms/Column.tsx
var Column = __webpack_require__(4992);
// EXTERNAL MODULE: ./src/components/grids/GenresGrid.tsx + 1 modules
var GenresGrid = __webpack_require__(6557);
// EXTERNAL MODULE: ./src/components/grids/LogosGrid.tsx
var LogosGrid = __webpack_require__(6009);
// EXTERNAL MODULE: ./src/components/layouts/MainLayout.tsx + 5 modules
var MainLayout = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/components/grids/PostsGrid.tsx + 1 modules
var PostsGrid = __webpack_require__(3237);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/use-immer/dist/use-immer.module.js
var use_immer_module = __webpack_require__(57);
// EXTERNAL MODULE: ./node_modules/jotai-immer/dist/index.modern.js + 1 modules
var dist_index_modern = __webpack_require__(8387);
// EXTERNAL MODULE: ./src/modules/privacy/index.ts + 1 modules
var privacy = __webpack_require__(354);
// EXTERNAL MODULE: ./src/modules/jotai/index.ts + 1 modules
var jotai = __webpack_require__(1262);
// EXTERNAL MODULE: ./src/components/atoms/StorylinerImage.tsx
var StorylinerImage = __webpack_require__(4090);
// EXTERNAL MODULE: ./src/components/elements/PreviewVideo.module.css
var PreviewVideo_module = __webpack_require__(2371);
var PreviewVideo_module_default = /*#__PURE__*/__webpack_require__.n(PreviewVideo_module);
;// CONCATENATED MODULE: ./src/components/elements/PreviewVideo.tsx
// import node_modules







// import modules


// import components

// import styles

// import components
var VideoModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7602).then(__webpack_require__.bind(__webpack_require__, 7602));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7602)
            ];
        }
    }
});
// PreviewVideo component
var PreviewVideo = function(param) {
    var videoPoster = param.videoPoster, videoTitle = param.videoTitle, videoUrl = param.videoUrl;
    // init hooks
    var _useImmerAtom = (0,_sliced_to_array/* default */.Z)((0,dist_index_modern/* useImmerAtom */.It)(jotai/* localeAtom */.S$), 1), locale = _useImmerAtom[0];
    // init state
    var _useImmer = (0,_sliced_to_array/* default */.Z)((0,use_immer_module/* useImmer */.x)(false), 2), modalState = _useImmer[0], setModalState = _useImmer[1];
    // init func
    var onToggleModal = react.useCallback(function() {
        setModalState(!modalState);
    }, [
        modalState,
        setModalState
    ]);
    // init iframe optin
    react.useEffect(function() {
        if (modalState) {
            (0,privacy/* iframeOptin */.Vk)({
                autoplay: true,
                locale: locale
            });
        } else {
            (0,privacy/* pauseVideos */.Qe)();
        }
    }, [
        locale,
        modalState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PreviewVideo_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PreviewVideo_module_default()).innerContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PreviewVideo_module_default()).imageContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PreviewVideo_module_default()).imageInnerContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: (PreviewVideo_module_default()).imageButton,
                                        onClick: onToggleModal,
                                        type: "button",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PreviewVideo_module_default()).imageButtonCanvas
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StorylinerImage["default"], {
                                                imageId: videoPoster,
                                                height: 900,
                                                title: videoTitle,
                                                width: 1440
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PreviewVideo_module_default()).snippetTop
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PreviewVideo_module_default()).snippetBottomLeft
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PreviewVideo_module_default()).snippetBottomRight
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PreviewVideo_module_default()).backgroundCanvas
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal, {
                closeModal: onToggleModal,
                isActive: modalState,
                videoTitle: videoTitle,
                videoUrl: videoUrl
            })
        ]
    });
};
PreviewVideo.propTypes = {
    videoPoster: prop_types.string.isRequired,
    videoTitle: prop_types.string.isRequired,
    videoUrl: prop_types.string.isRequired
};
/* harmony default export */ var elements_PreviewVideo = (PreviewVideo);

// EXTERNAL MODULE: ./src/components/meta/SEO.tsx
var SEO = __webpack_require__(8897);
// EXTERNAL MODULE: ./src/components/atoms/Section.tsx
var Section = __webpack_require__(9748);
// EXTERNAL MODULE: ./src/components/templates/HomeTemplate.module.css
var HomeTemplate_module = __webpack_require__(2841);
var HomeTemplate_module_default = /*#__PURE__*/__webpack_require__.n(HomeTemplate_module);
;// CONCATENATED MODULE: ./src/components/templates/HomeTemplate.tsx
/* eslint-disable jsx-a11y/alt-text */ // import node_modules






// import types

// import components








// import styles

// import dynamically
var EarlyAccessSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3192).then(__webpack_require__.bind(__webpack_require__, 3192));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3192)
            ];
        }
    }
});
var LinkComponent = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2964));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2964)
            ];
        }
    }
});
var Quote = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 715).then(__webpack_require__.bind(__webpack_require__, 715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(715)
            ];
        }
    }
});
var StorylinerIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9070).then(__webpack_require__.bind(__webpack_require__, 9070));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9070)
            ];
        }
    }
});
var HomeTemplate_StorylinerImage = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4090));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4090)
            ];
        }
    }
});
// define page
var HomeTemplate = function(param) {
    var blogPosts = param.blogPosts, hrefLang = param.hrefLang, templateGenres = param.templateGenres;
    // init hooks
    var t = (0,useTranslation/* useTranslation */.$)("home").t;
    // init render
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                description: t("seo.description"),
                hrefLang: hrefLang,
                image: t("seo.image"),
                title: t("seo.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                mobileHeight: "25px",
                                tabletHeight: "50px",
                                height: "75px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                            cols: "ml",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                    alignment: "center",
                                    tag: "h1",
                                    isHyphenated: false,
                                    children: t("hero.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                    alignment: "center",
                                    size: "large",
                                    children: t("hero.intro")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_PreviewVideo, {
                        videoPoster: t("productPreview.videoPoster"),
                        videoTitle: t("hero.title"),
                        videoUrl: t("productPreview.videoUrl")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "tuatara",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                alignment: "center",
                                tag: "label",
                                children: t("press.title")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogosGrid/* default */.Z, {
                        bgColor: "tuatara",
                        logos: t("press.logos", {
                            returnObjects: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgImage: t("press.dividerBottom"),
                        bgPosition: "center bottom",
                        zIndex: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "100px",
                            tabletHeight: "125px",
                            height: "175px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                    alignment: "center",
                                    tag: "h2",
                                    children: t("benefits.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                    mobileHeight: "25px",
                                    height: "25px"
                                })
                            ]
                        })
                    }),
                    t("benefits.items", {
                        returnObjects: true
                    }).map(function(benefit, index) {
                        if (index % 2 !== 0) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
                                        mobileFlexDirection: "column-reverse",
                                        tabletFlexDirection: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                                                cols: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                                        alignment: "left",
                                                        tag: "h3",
                                                        children: benefit.headline
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                                        alignment: "left",
                                                        children: benefit.description
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                                cols: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTemplate_StorylinerImage, {
                                                    imageId: benefit.image,
                                                    height: 560,
                                                    title: benefit.headline,
                                                    width: 960
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                                        bgColor: "white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                            height: "25px"
                                        })
                                    })
                                ]
                            }, benefit.headline);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
                                    mobileFlexDirection: "column",
                                    tabletFlexDirection: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                            cols: 2,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTemplate_StorylinerImage, {
                                                imageId: benefit.image,
                                                height: 560,
                                                title: benefit.headline,
                                                width: 960
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                                            cols: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                                    alignment: "left",
                                                    tag: "h3",
                                                    children: benefit.headline
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                                    alignment: "left",
                                                    children: benefit.description
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                                    bgColor: "white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                        height: "25px"
                                    })
                                })
                            ]
                        }, benefit.headline);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "button-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent, {
                                    href: t("benefits.callToAction.href"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* LinkButton */.Qj, {
                                        color: "naked",
                                        size: "large",
                                        text: t("benefits.callToAction.label"),
                                        iconRight: "ri-arrow-right-line",
                                        textIsPrimary: true
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "allports",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote, {
                        bgColor: t("testimonial.bgColor"),
                        color: t("testimonial.color"),
                        colorDark: t("testimonial.colorDark"),
                        image: t("testimonial.image"),
                        jobTitle: t("testimonial.jobTitle"),
                        name: t("testimonial.name"),
                        quote: t("testimonial.quote"),
                        snippet: t("testimonial.snippet"),
                        snippetDark: t("testimonial.snippetDark")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "allports",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
                        bgColor: "desertStorm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                                className: (HomeTemplate_module_default())["genre-grid-intro"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                        alignment: "left",
                                        tag: "h3",
                                        children: t("genres.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                        alignment: "left",
                                        children: t("genres.intro")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "button-container button-left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent, {
                                            href: t("genres.callToAction.href"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* LinkButton */.Qj, {
                                                color: "ultraLight",
                                                text: t("genres.callToAction.label"),
                                                iconRight: "ri-arrow-right-line",
                                                textIsPrimary: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                className: (HomeTemplate_module_default())["genre-grid-container"],
                                isPaddingless: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenresGrid/* default */.Z, {
                                    bgColor: "desertStorm",
                                    templateGenres: templateGenres
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgImage: t("genres.dividerBottom"),
                        bgImageDark: t("genres.dividerBottomDark"),
                        bgPosition: "center bottom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "100px",
                            tabletHeight: "125px",
                            height: "150px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                    alignment: "center",
                                    tag: "h3",
                                    children: t("audiences.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                    height: "24px"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
                        verticalAlignment: "top",
                        children: [
                            t("audiences.items", {
                                returnObjects: true
                            }).map(function(audience) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                                    cols: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StorylinerIcon, {
                                            icon: audience.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                            height: "8px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                            alignment: "left",
                                            tag: "h4",
                                            children: audience.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                            alignment: "left",
                                            children: audience.description
                                        })
                                    ]
                                }, audience.name);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                cols: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "button-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent, {
                                    href: t("audiences.callToAction.href"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* LinkButton */.Qj, {
                                        color: "naked",
                                        size: "large",
                                        text: t("audiences.callToAction.label"),
                                        iconRight: "ri-arrow-right-line",
                                        textIsPrimary: true
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                            cols: "ml",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                alignment: "center",
                                isHyphenated: false,
                                tag: "h2",
                                children: t("blog.title")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsGrid/* default */.Z, {
                        bgColor: "desertStorm",
                        blogPosts: blogPosts
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EarlyAccessSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "100px"
                        })
                    })
                ]
            })
        ]
    });
};
HomeTemplate.propTypes = {
    blogPosts: prop_types.arrayOf(prop_types.shape({
        image: prop_types.string.isRequired,
        slug: prop_types.string.isRequired,
        tags: prop_types.arrayOf(prop_types.string.isRequired).isRequired,
        title: prop_types.string.isRequired
    }).isRequired).isRequired,
    hrefLang: prop_types.string.isRequired,
    templateGenres: prop_types.arrayOf(prop_types.shape({
        slug: prop_types.oneOf(Object.values(index_modern/* TemplateGenreSlugEnum */.V)).isRequired,
        coverImageSquared: prop_types.string.isRequired,
        name: prop_types.string.isRequired
    }).isRequired).isRequired
};
/* harmony default export */ var templates_HomeTemplate = (HomeTemplate);


/***/ }),

/***/ 354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vk": function() { return /* reexport */ iframeOptin; },
  "Qe": function() { return /* reexport */ pauseVideos; }
});

// UNUSED EXPORTS: getYoutubeId

// EXTERNAL MODULE: ./node_modules/striptags/src/striptags.js
var striptags = __webpack_require__(3726);
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);
// EXTERNAL MODULE: ./src/modules/i18n/index.ts + 50 modules
var i18n = __webpack_require__(9798);
;// CONCATENATED MODULE: ./src/modules/privacy/iframe-optin.ts
/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable no-loop-func */ // import node_modules

// import providers

// define modules
function getYoutubeId(param) {
    var youtubeUrl = param.youtubeUrl;
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = youtubeUrl.match(regExp);
    return match && match[7].length === 11 ? match[7] : false;
}
function pauseVideos() {
    // get iframe elements and show user cookie information
    var iframes = document.getElementsByTagName("IFRAME");
    // loop over iframes and pause
    for(var i = 0; i < iframes.length; i += 1){
        var iframe = iframes[i];
        // check element
        if (iframe) {
            var // pause video
            _iframe_contentWindow;
            // create stop command
            var stopCommand = JSON.stringify({
                event: "command",
                func: "pauseVideo"
            });
            iframe === null || iframe === void 0 ? void 0 : (_iframe_contentWindow = iframe.contentWindow) === null || _iframe_contentWindow === void 0 ? void 0 : _iframe_contentWindow.postMessage(stopCommand, "*");
        }
    }
}
// optin service for third party embeds
function iframeOptin(param) {
    var autoplay = param.autoplay, locale = param.locale;
    // get iframe elements and show user cookie information
    var iframes = document.getElementsByTagName("IFRAME");
    for(var i = 0; i < iframes.length; i += 1){
        var _iframe_src;
        var iframe = iframes[i];
        // check youtube embed
        if (iframe === null || iframe === void 0 ? void 0 : (_iframe_src = iframe.src) === null || _iframe_src === void 0 ? void 0 : _iframe_src.includes("youtube")) {
            var // replace iframe with canvas
            _iframe_parentNode, _window_cookiehub;
            // get meta data from iframe
            var title = (iframe === null || iframe === void 0 ? void 0 : iframe.title) ? striptags_default()(iframe === null || iframe === void 0 ? void 0 : iframe.title) : "Storyliner";
            var youtubeId = getYoutubeId({
                youtubeUrl: iframe === null || iframe === void 0 ? void 0 : iframe.src
            });
            // get info text
            var infoText = i18n/* i18n.getResource */.ag.getResource(locale, "components", "EmbedOptin.Youtube.infoText");
            var buttonText = i18n/* i18n.getResource */.ag.getResource(locale, "components", "EmbedOptin.Youtube.buttonText");
            // create optin canvas
            var optinWrapper = document.createElement("DIV");
            optinWrapper.className = "iframe-wrapper";
            optinWrapper.innerHTML = '<div class="optin-canvas" id="optin-canvas" data-youtube-id="'.concat(youtubeId, '" data-title="').concat(title, '"><div class="icon-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M19.606 6.995c-.076-.298-.292-.523-.539-.592C18.63 6.28 16.5 6 12 6s-6.628.28-7.069.403c-.244.068-.46.293-.537.592C4.285 7.419 4 9.196 4 12s.285 4.58.394 5.006c.076.297.292.522.538.59C5.372 17.72 7.5 18 12 18s6.629-.28 7.069-.403c.244-.068.46-.293.537-.592C19.715 16.581 20 14.8 20 12s-.285-4.58-.394-5.005zm1.937-.497C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5v-7l6 3.5-6 3.5z"/></svg></div><div class="info-text">').concat(infoText, '</div><div class="button-wrapper"><button class="optin-button" type="text" id="optin-button">').concat(buttonText, "</button></div></div>");
            // create optin handler
            var optin = function() {
                var // replace iframe with canvas
                _optinCanvas_parentNode;
                // because of build
                if (false) {}
                // create new iframe
                localStorage.setItem("youtube-optin", "true");
                // get canvas
                var iframeContainer = document.getElementsByClassName("iframe-wrapper")[0];
                var optinCanvas = document.getElementById("optin-canvas");
                // create new iframe
                var newIframe = document.createElement("IFRAME");
                newIframe.src = "https://www.youtube-nocookie.com/embed/".concat(optinCanvas === null || optinCanvas === void 0 ? void 0 : optinCanvas.getAttribute("data-youtube-id"), "?version=3&enablejsapi=1&&autoplay=").concat(autoplay ? 1 : 0);
                newIframe.title = (optinCanvas === null || optinCanvas === void 0 ? void 0 : optinCanvas.getAttribute("data-title")) || "Storyliner";
                newIframe.width = (iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.clientWidth) ? "".concat(iframeContainer.clientWidth, "px") : "680px";
                newIframe.height = (iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.clientHeight) ? "".concat(iframeContainer.clientHeight, "px") : "440px";
                newIframe.frameborder = "0";
                newIframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
                newIframe.allowfullscreen = true;
                optinCanvas === null || optinCanvas === void 0 ? void 0 : (_optinCanvas_parentNode = optinCanvas.parentNode) === null || _optinCanvas_parentNode === void 0 ? void 0 : _optinCanvas_parentNode.replaceChild(newIframe, optinCanvas);
            };
            iframe === null || iframe === void 0 ? void 0 : (_iframe_parentNode = iframe.parentNode) === null || _iframe_parentNode === void 0 ? void 0 : _iframe_parentNode.replaceChild(optinWrapper, iframes[i]);
            // attach event handler
            var optinButton = document.getElementById("optin-button");
            if (optinButton) {
                optinButton.onclick = optin;
            }
            // check if already opted in
            // https://support.cookiehub.com/article/75-youtube-embed-videos
            // @ts-ignore
            if (localStorage.getItem("youtube-optin") || (window === null || window === void 0 ? void 0 : (_window_cookiehub = window.cookiehub) === null || _window_cookiehub === void 0 ? void 0 : _window_cookiehub.hasConsented("analytics"))) {
                optin();
            }
        }
    }
}

;// CONCATENATED MODULE: ./src/modules/privacy/index.ts
// export modules



/***/ }),

/***/ 4869:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"storyliner-fp8hXG","fade-in":"storyliner-HRUTCg","divider-bottom-allports-1":"storyliner-l6b301","divider-bottom-allports-2":"storyliner-9efydj","divider-bottom-anakiwa-1":"storyliner-8XYClx","divider-bottom-desertstorm-1":"storyliner-qIAbW1","divider-bottom-tuatuara-1":"storyliner-BpvUG6","divider-bottom-rouge-1":"storyliner-v9MYZk","divider-bottom-tawnyport-1":"storyliner-5YepYC","divider-top-desertstorm-1":"storyliner-xQ2NTx","divider-top-tuatuara-1":"storyliner-v4UBxG","col-1":"storyliner-jYcL9e","col-2":"storyliner-ncBrCH","col-3":"storyliner-ZYqzkT","col-4":"storyliner-xd20GK","col-5":"storyliner-C0fNxx","top":"storyliner-zW3Fhs","center":"storyliner-DvhTxA","bottom":"storyliner-uF2NnY","color-white":"storyliner-yrLBPw","color-energyYellow":"storyliner-qotEn7","color-allports":"storyliner-akp94Y","color-desertStorm":"storyliner-9TcT1s","color-anakiwa":"storyliner-YxjxMB","color-tuatara":"storyliner-pc3xRC","color-java":"storyliner-21KAvm","divider-bottom-allports-1-dark":"storyliner-uJpYIG","divider-bottom-allports-2-dark":"storyliner-zi6AEt","divider-bottom-anakiwa-1-dark":"storyliner-04IxYv","divider-bottom-desertstorm-1-dark":"storyliner-6nCano","divider-bottom-tuatuara-1-dark":"storyliner-EvQnQp","divider-bottom-rouge-1-dark":"storyliner-xzPjY8","divider-bottom-tawnyport-1-dark":"storyliner-Xbpe4f","divider-top-desertstorm-1-dark":"storyliner-Be5JWk","divider-top-tuatuara-1-dark":"storyliner-9zcWcL","container":"storyliner-JxkvJT"};

/***/ }),

/***/ 2848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"storyliner-vbD9mK","fade-in":"storyliner-eNwawO","is-rounded":"storyliner-kV1a7W","is-white":"storyliner-FVEYZh","is-black":"storyliner-dc3Q7B","has-shadow":"storyliner-QcsozF","white-bg":"storyliner-bi4CsT"};

/***/ }),

/***/ 7121:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardNameContainer":"storyliner-YbTrb6","cardImage":"storyliner-PiY6Eg","cardImageContainer":"storyliner-hTxDXt","card":"storyliner-fGy17P","container":"storyliner-ZnSpWa"};

/***/ }),

/***/ 765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"storyliner-K8ko3T","nameContainer":"storyliner-lSIsQF","imageContainer":"storyliner-jS8HMG","heading":"storyliner-AMaodO","card":"storyliner-2CMZRN"};

/***/ }),

/***/ 2371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backgroundCanvas":"storyliner-vk287H","snippetBottomRight":"storyliner-0oS9LG","snippetBottomLeft":"storyliner-9Wy6xG","snippetTop":"storyliner-KpYgnW","imageButtonCanvas":"storyliner-Q2Ttox","imageButton":"storyliner-fiSyIz","imageInnerContainer":"storyliner-jZkzS3","imageContainer":"storyliner-0FfbFf","innerContainer":"storyliner-HFivxK","container":"storyliner-9zxz09"};

/***/ }),

/***/ 9888:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"column":"storyliner-2QeAbJ"};

/***/ }),

/***/ 2841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genre-grid-intro":"storyliner-sEiptb","genre-grid-container":"storyliner-3p6CPL"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7645)


/***/ }),

/***/ 4654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);